// Import CSS for bundling
import '../css/main.css'

// Import Swiper CSS
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'

// Import JavaScript libraries
import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'

// Initialize Alpine.js with Intersect plugin
window.Alpine = Alpine
Alpine.plugin(intersect)
Alpine.start()

// Configure Swiper modules
Swiper.use([Navigation, Pagination, Autoplay])

async function checkScroll() {
    const navbar = document.querySelector(".main-navbar");
    if (!navbar) return;

    if (window.scrollY >= window.innerHeight / 2) {
        navbar.classList.add("sticky-navbar");
    } else {
        navbar.classList.remove("sticky-navbar");
    }
}

window.addEventListener("scroll", async () => {
    await checkScroll();
});



window.addEventListener('load', () => {
    const loader = document.querySelector('#logo-loader');
    loader.classList.add('loader-fade');
    setTimeout(() => {
        loader.classList.add('hidden')
    }, 900);

});

const button = document.getElementById('scrollButton');
if (button) {
    button.addEventListener('click', () => {
        window.scrollBy({
            top: window.innerHeight / 5 * 4,
            behavior: 'smooth'
        });
    });
}


document.addEventListener('DOMContentLoaded', function () {
    var darkTogglerCheckbox = document.querySelector('#darkToggler');
    var html = document.querySelector('html');
    var logoSvgs = document.querySelectorAll('#animated-logo');
    //logo animated 
    logoSvgs.forEach(function (logo) {
        logo.classList.add('active');
    });
    // Function to toggle dark mode
    var darkModeToggler = function darkModeToggler() {
        if (darkTogglerCheckbox.checked) {
            html.classList.add('dark');
            localStorage.setItem('darkMode', 'true'); // Store the dark mode preference
        } else {
            html.classList.remove('dark');
            localStorage.setItem('darkMode', 'false'); // Store the light mode preference
        }
    };

    // Check if dark mode preference is stored and apply it
    var storedDarkMode = localStorage.getItem('darkMode');
    if (storedDarkMode === 'true') {
        darkTogglerCheckbox.checked = true;
        html.classList.add('dark');
    }

    // Add event listener to the dark mode toggler checkbox
    darkTogglerCheckbox.addEventListener('click', darkModeToggler);
});


//////////////////////////////// All swipers code////////////////////////////
const swiper = new Swiper('.swiper', {
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    loop: true,
    speed: 400,
    centeredSlides: true,
    navigation: {
        nextEl: '.swiper-button-next2',
        prevEl: '.swiper-button-prev2',
    },

    pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
    },
    breakpoints: {
        640: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
    }
});



const mainswiper = new Swiper('.HomePageMainSwiper', {
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    loop: true,
    speed: 1500,
    centeredSlides: true,
    navigation: {
        nextEl: '.swiper-button-next-mainswiper',
        prevEl: '.swiper-button-prev-mainswiper',
    },

    pagination: {
        el: ".swiper-pagination-mainswiper",
        clickable: true,
        dynamicBullets: true,
    },
    breakpoints: {
        640: {
            slidesPerView: 1,
            spaceBetween: 50,
        },
        768: {
            slidesPerView: 1,
            spaceBetween: 40,
        },
        1024: {
            slidesPerView: 1,
            spaceBetween: 50,
        },
    }
});





const swiper3 = new Swiper('.mySwiper4', {
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    loop: false,
    speed: 400,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    pagination: {
        el: ".swiper-pagination2",
        clickable: true,
        dynamicBullets: true,
    },
    breakpoints: {
        640: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        1024: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
    }
});


const projectswiper = new Swiper(".projectsSwiper", {
    centeredSlides: true,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },

    pagination: {
        el: ".projects-swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + "</span>";
        },
    },
});

//////////////////////////////// Tabs////////////////////////////
// section menu active
function onScroll(event) {
    const sections = document.querySelectorAll(".menu-scroll");
    const scrollPos =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
    try {
        for (let i = 0; i < sections.length; i++) {
            const currLink = sections[i];
            const val = currLink.getAttribute("href");
            if (val == null) continue;

            const refElement = document.querySelector(val);
            const scrollTopMinus = scrollPos + 73;
            if (
                refElement.offsetTop <= scrollTopMinus &&
                refElement.offsetTop + refElement.offsetHeight > scrollTopMinus
            ) {
                document.querySelector(".menu-scroll").classList.remove("active");
                currLink.classList.add("active");
            } else {
                currLink.classList.remove("active");
            }
        }
    } catch (e) {

    }
}

window.document.addEventListener("scroll", onScroll);
// ==== Tabs
document.addEventListener('DOMContentLoaded', function () {
    const tabButtons = document.querySelectorAll(".tabButtons button");
    const tabPanels = document.querySelectorAll(".tabPanel");

    function showPanel(panelIndex) {
        tabButtons.forEach(function (node) {
            node.classList.remove(
                "text-primary",
                "border-primary",
                "dark:border-slate-500",
                "text-white",
                "bg-primary"
            );
            node.classList.add('bg-chetwodeBlue/10');
        });

        // Add active class to the selected button
        if (tabButtons[panelIndex]) {
            tabButtons[panelIndex].classList.remove(
                "bg-chetwodeBlue/10"
            );
            tabButtons[panelIndex].classList.add(
                "bg-primary",
                "text-white"
            );
        }

        // Hide all panels
        tabPanels.forEach(function (node) {
            node.style.display = "none";
        });

        // Show the selected panel
        if (tabPanels[panelIndex]) {
            tabPanels[panelIndex].style.display = "block";
        }
    }

    // Attach event listeners to tab buttons
    tabButtons.forEach((button, index) => {
        button.addEventListener('click', () => {
            showPanel(index);
        });
    });

    // Show the first panel by default
    showPanel(0);
});

// handle opening, closing and fetching the client modal details
window.openClientModal = async function (element) {
    // const clientId = element.getAttribute('data-client-id');
    const clientName = (element.getAttribute('data-client-name') || "").trim() || "Unknown Client";
    const clientImage = (element.getAttribute('data-client-image') || "").trim() || "/src/images/fallback-client.png";
    const clientDescription = (element.getAttribute('data-client-description') || "").trim() || "No description available";

    // Populate the modal with client details
    document.getElementById('clientName').innerText = clientName;
    document.getElementById('clientImage').src = clientImage;
    document.getElementById('clientDescription').innerText = clientDescription;
    document.getElementById('clientModal').classList.remove('hidden');
}

window.closeClientModal = function () {
    document.getElementById('clientModal').classList.add('hidden');
}

// cube-master Home page slider
document.addEventListener('DOMContentLoaded', function () {
    const imageContainer = document.querySelector(".imageContainer");
    if (!imageContainer) return; // Exit if imageContainer doesn't exist

    const images = Array.from(imageContainer.querySelectorAll("img"));
    const sliderContent = document.querySelector(".sliderContent");
    if (!sliderContent) return; // Exit if sliderContent doesn't exist

    const dynamicTitle = sliderContent.querySelector(".dynamic-title");
    const dynamicBodyText = sliderContent.querySelector(".dynamic-body-text");
    const nextBtn = imageContainer.querySelector(".next-btn");
    const prevBtn = imageContainer.querySelector(".prev-btn");
    const isRTL = document.documentElement.getAttribute('dir') === 'rtl';

    const radius = 200;
    let currentIndex = 0;
    let autoRotate = setInterval(nextSlide, 4000);

    function updateSlider() {
        if (images.length === 0) return;
        images.forEach((img) => img.classList.remove("active"));
        // get current image
        const currentImage = images[currentIndex];
        currentImage.classList.add("active");
        // convert html to plain text and remove &nbsp;
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = currentImage.dataset.bodyText;
        const plainTextBody = tempDiv.textContent.replace(/\u00A0/g, " ").trim();
        // update dynamic content using data attributes and fade out current text before updating
        if (dynamicTitle && dynamicBodyText) {
            dynamicTitle.classList.remove("active");
            dynamicBodyText.classList.remove("active");

            // Wait for the fade-out transition to complete
            setTimeout(() => {
                dynamicTitle.textContent = currentImage.dataset.title?.trim() || "No Title";
                dynamicBodyText.textContent = plainTextBody || "No Description";
                dynamicTitle.classList.add("active");
                dynamicBodyText.classList.add("active");
            }, 500);
        }

        // Position images in a circular path
        images.forEach((img, index) => {
            // Calculate angle based on direction
            const angleOffset = isRTL ? 0 : 180;
            const angle = ((index - currentIndex) * -90 + angleOffset) % 360;
            const radians = (angle * Math.PI) / 180;
            img.style.transform = `translate(${radius * Math.cos(radians)}px, ${radius * Math.sin(radians)}px)`;
        });
    }

    function nextSlide() {
        currentIndex = (currentIndex + 1) % images.length;
        updateSlider();
    }

    function prevSlide() {
        currentIndex = (currentIndex - 1 + images.length) % images.length;
        updateSlider();
    }

    nextBtn.addEventListener("click", () => {
        clearInterval(autoRotate);
        nextSlide();
        autoRotate = setInterval(nextSlide, 4000);
    });

    prevBtn.addEventListener("click", () => {
        clearInterval(autoRotate);
        prevSlide();
        autoRotate = setInterval(nextSlide, 4000);
    });

    updateSlider();
});

// common issues
document.addEventListener('DOMContentLoaded', function () {
    const commonIssues = document.querySelectorAll('.common-issues .after-column li');
    if (commonIssues) {
        commonIssues.forEach(function (issue) {
            issue.addEventListener('click', function () {
                if (issue.classList.contains('active')) {
                    issue.classList.remove('active');
                } else {
                    commonIssues.forEach(function (issue) {
                        issue.classList.remove('active');
                    });
                    issue.classList.add('active');
                }
            })
        });
    }
});

// !! IF YOU ARE USING THIS FILE DONT FORGET TO MINIFY IT IN main-min.js FILE !!
// !! IF YOU ARE USING THIS  FILE DONT FORGET TO MINIFY IT IN main-min.js FILE !!